<template>
  <div class="one-login"></div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name: "OneLogin",
    data() {
        return {
            userData: '',
        }
    },
    created() {
        // 获取url参数
        const url = window.location.href;
        const params = {};
        const regEx = /[?&]([^=#]+)=([^&#]*)/g;
        let match;
        while ((match = regEx.exec(url))) {
            params[match[1]] = decodeURIComponent(match[2]);
        }
        const sign = params.sign;
        const code = params.code;
        const timestamp = params.timestamp;
        if (sign && code && timestamp) {
            this.oneSsoLogin(sign, code, timestamp)
        }
    },
    methods: {
        ...mapActions(['oneloginSso']),
        async oneSsoLogin(sign, code, timestamp) {
            let param = { sign: sign, code: code, timestamp: timestamp }
            this.oneloginSso(param)
        }
    },
}
</script>